import { useEffect, useState } from "react";
import { APP_TITLE } from "../../../config/constant";
import { useOutletContext } from "react-router";
import DashboardHeader from "../dashboard/components/DashboardHeader";
import styled from "styled-components";
import TotalSales from "./SalesInsightComponent/TotalSales";
import {
    generateRandomValues,
    GrossMarginChartOptions,
    totalSalesChartOptions,
    totalSalesChartSeriesA,
    totalSalesChartSeriesB,
    totalSalesChartSeriesC,
    totalSalesChartSeriesZero,
    visitorChartSeriesA,
    visitorChartSeriesB,
    visitorChartSeriesC
} from "../../../utils/utilHelpers";
import ProductInsight from "./SalesInsightComponent/ProductInsight";
import AnalyticsGraph from "./SalesInsightComponent/AnalyticsGraph";
import TopCustomer from "./SalesInsightComponent/TopCustomer";

const StyledPage = styled.div`
    &.dashboard-container {
        padding-bottom: 30px;
    }

    .dashboad-header-container {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 15px 24px;
    }
    .header-first-portion {
        display: flex;
        gap: 16px;
        align-items: center;
    }
    .dashboard-header-data-labels {
        height: 35px;
        display: flex;
        align-items: center;
        padding: 0px 8px;
        border-radius: 4px;
        background-color: #005fcc30;
        color: #00aeef;
        font-size: 12px;
        font-weight: 500;
    }
    .dashboard-header-btn {
        height: 35px;
        width: 120px;
        border-radius: 4px;
        font-size: 10px;
        font-weight: 400;
        background-color: #1e2631;
        outline: none;
        border: none;
        color: #d1d1d1;
    }
    .total-sale-chart {
        display: grid;
        align-items: center;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 24px;
    }
    .three-component-container {
        display: grid;
        align-items: center;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 24px;
    }
`;

export default function SalesInsightPage() {
    document.title = `${APP_TITLE} - Sales Insight`;
    /* #region VARS */
    const [visitorChartSeries, setVistorChartSeries] = useState([
        {
            name: "series-1",
            data: []
        }
    ]);
    const [totalSalesChartSeriesData, setTotalSalesChartSeriesData] = useState(totalSalesChartSeriesZero || []);
    const [chartData, setChartData] = useState({
        percentage: 0,
        nokValue: 0,
        other: 0,
        nokPercentage: 0,
        grossPercentage: 0,
        salesPercentage: 0,
        comparedPercentage: 0,
        comparedValue1st: 0,
        comparedValue2nd: 0,
        comparedValue3rd: 0
    });
    const { MainLayoutProps, layoutType } = useOutletContext();

    const props = {
        layoutType: layoutType,
        setControlBarLeftBtns: MainLayoutProps?.setControlBarLeftBtns,
        setControlBarCenterBtns: MainLayoutProps?.setControlBarCenterBtns,
        setControlBarRightBtns: MainLayoutProps?.setControlBarRightBtns,
        setFilterHeaderProperties: MainLayoutProps?.setFilterHeaderProperties,
        setRefreshUserData: MainLayoutProps?.setRefreshUserData
    };

    const productInfo = {
        image: "https://bo7storage7demo.blob.core.windows.net/bo-images/hzod78lyvqa1740401951845.jpg",
        name: "Brodie Biker Jacket",
        price: "7.000",
        amountCurrency: "NOK"
    };
    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        if (!props?.layoutType) return;
        setupHeaders(props, updateData);
    }, [props?.layoutType]);
    /* #endregion */

    /* #region METHODS */

    const updateData = () => {
        const data = [visitorChartSeriesA, visitorChartSeriesB, visitorChartSeriesC];
        const totalSalesData = [totalSalesChartSeriesA, totalSalesChartSeriesB, totalSalesChartSeriesC];
        const visitorChartSeries = data[Math.floor(Math.random() * 3)];
        const totalSalesChartSeries = totalSalesData[Math.floor(Math.random() * 3)];
        const {
            NOK,
            percentage,
            other,
            grossPercentage,
            nokPercentage,
            salesPercentage,
            comparedPercentage,
            comparedValue1st,
            comparedValue2nd,
            comparedValue3rd
        } = generateRandomValues();
        setChartData({
            nokValue: NOK,
            percentage,
            other,
            grossPercentage,
            nokPercentage,
            salesPercentage,
            comparedPercentage,
            comparedValue1st,
            comparedValue2nd,
            comparedValue3rd
        });
        setVistorChartSeries(visitorChartSeries);
        setTotalSalesChartSeriesData(totalSalesChartSeries);
    };

    /* #endregion */

    return (
        <StyledPage className="dashboard-container">
            <div className="total-sale-chart">
                <TotalSales
                    title={"TOTAL SALES"}
                    totalSalesChartSeries={totalSalesChartSeriesData}
                    totalValue={chartData.nokValue || 0}
                    totalValueCurrency={"NOK"}
                    subText={"Total revenue over the selected period"}
                    options={JSON.parse(JSON.stringify(totalSalesChartOptions))}
                />
                <TotalSales
                    title={"Total Orders"}
                    totalSalesChartSeries={totalSalesChartSeriesData}
                    totalValue={chartData.nokValue || 0}
                    totalValueCurrency={"NOK"}
                    subText={"Number of Shopify POS transactions"}
                    options={JSON.parse(JSON.stringify(totalSalesChartOptions))}
                />
                <TotalSales
                    title={"AVG. Order Value"}
                    totalSalesChartSeries={totalSalesChartSeriesData}
                    totalValue={chartData.nokValue || 0}
                    totalValueCurrency={"NOK"}
                    subText={"Revenue ÷ Total Orders"}
                    options={JSON.parse(JSON.stringify(totalSalesChartOptions))}
                />
                <ProductInsight
                    title={"FASTEST (BEST) SELLING PRODUCT"}
                    totalValue={chartData.nokValue || 0}
                    productInfo={productInfo}
                />
                <ProductInsight
                    title={"SLOWEST PRODUCT"}
                    totalValue={chartData.nokValue || 0}
                    productInfo={productInfo}
                />
                <TotalSales
                    title={"AVG. STOCK ROTATION"}
                    totalSalesChartSeries={totalSalesChartSeriesData}
                    totalValue={chartData.nokValue || 0}
                    totalValueCurrency={"NOK"}
                    subText={"Avg. time to sell a product"}
                    options={JSON.parse(JSON.stringify(totalSalesChartOptions))}
                />
                <TotalSales
                    title={"Top Payment Method"}
                    totalSalesChartSeries={totalSalesChartSeriesData}
                    totalValue={chartData.nokValue || 0}
                    totalValueCurrency={"NOK"}
                    subText={"Most used payment type"}
                    options={JSON.parse(JSON.stringify(totalSalesChartOptions))}
                />
                <TotalSales
                    title={"Return Rate"}
                    totalSalesChartSeries={totalSalesChartSeriesData}
                    totalValue={chartData?.percentage || 0}
                    totalValueCurrency={"%"}
                    subText={"% of orders refunded/returned"}
                    options={JSON.parse(JSON.stringify(GrossMarginChartOptions))}
                />
                <TotalSales
                    title={"AVG. BASKET"}
                    totalSalesChartSeries={totalSalesChartSeriesData}
                    totalValue={chartData.nokValue || 0}
                    totalValueCurrency={""}
                    subText={"Number of sales per month / no. of receipts"}
                    options={JSON.parse(JSON.stringify(totalSalesChartOptions))}
                />
            </div>
            <div className="graph-container-two">
                <AnalyticsGraph chartData={visitorChartSeries} />
                <TopCustomer />
            </div>
        </StyledPage>
    );
}

/* #region Set Header CTA */
function setupHeaders(props, updateData) {
    props.setControlBarLeftBtns([]);
    props.setControlBarCenterBtns([
        { to: "/sales-insight", active: true, disabled: false, title: "OVERVIEW" },
        { to: "#", active: false, disabled: true, title: "REPORTS" },
        { to: "#", active: false, disabled: true, title: "RETURNS & REFUNDS" }
    ]);
    props.setControlBarRightBtns([]);

    props.setFilterHeaderProperties({
        customContentHeader: <DashboardHeader onClick={updateData} buttonText="CHANGE" />
    });
}
/* endregion */
